@if (branchReady) {
  <router-outlet />
}

@if (showloader) {
  <div class="loading-container">
    <app-loading></app-loading>
  </div>
}
